import { render, staticRenderFns } from "./ChangeLockerButton.vue?vue&type=template&id=05d2c587&lang=pug&"
import script from "./ChangeLockerButton.vue?vue&type=script&lang=js&"
export * from "./ChangeLockerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports